export default __webpack_public_path__ + "static/media/freeflightt.b80493e6.svg";